import React, { useEffect, useState } from "react";
import whatsapp from "../../Images/Group 534.png";
import arrow2 from "../../Images/Vector (11).png";
import heart from "../../Images/Vector (10).png";
import redHeart from "../../Images/red-heart.png";
import plus from "../../Images/Vector@2x.png";
import HomeService from "../../Services/HomeService";
import { useLocation } from "react-router-dom";
import Header from "../../Layout/Header";
import Sidebar from "../../Layout/Sidebar";
import noimage from "../../Images/nophoto.jpg"

const ListOfFavourites = () => {
  const [properties, setProperties] = useState([]);
  const [userId, setUserId] = useState("");
  const [isClicked, setIsClicked] = useState(false);

  // const location = useLocation();

  // Fetch login profile
  const fetchLoginProfile = async () => {
    try {
      const response = await HomeService.getProfile();
      setUserId(response.data?._id || "");
    } catch (error) {
      console.error("Error fetching login profile:", error);
    }
  };

  const handleClick = async (propertyId) => {
    try {
      const data = {
        userId: userId,
        propertyId: propertyId,
      };
      const res = await HomeService.addToWishList(data);
      console.log("wishlist adding status", res);

      if (res?.status) {
        console.log("Property added to wishlist:", res);
        if (isClicked === true) {
          setIsClicked(false);
        }
        if (isClicked === false) {
          setIsClicked(true);
        }
      } else {
        console.error("Failed to add property to wishlist:", res?.message);
      }
    } catch (error) {
      console.error("Error adding property to wishlist:", error);
    }
  };

  const [loading, setLoading] = useState(false)
  // Fetch all properties
  const fetchAllProperty = async () => {
    setLoading(true)
    try {
      const response = await HomeService.getProperties({ userId });
      if (response?.status) {
        setProperties(() => {
          const data = response.data.filter(
            (property) => property?.isFavorite === true
          );
          setLoading(false)
          return data;
        });
      }
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  };

  useEffect(() => {
    fetchLoginProfile();
  }, []);

  useEffect(() => {
    if (userId) {
      fetchAllProperty();
    }
  }, [userId, isClicked]);

  const handleShareClick = (property) => {
    const subject = `${property.propertytype?.propertyType} in ${property.locality?.name}`;
    const body = `I am interested in the ${property.propertytype?.propertyType} at ${property.address}.` +
      `%0D%0AFound information from Winners`;

    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${body}`;

    const link = document.createElement('a');
    link.href = mailtoLink;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  const openWhatsAppLink = (e, phoneNumber, textMessage) => {
    e.preventDefault()
    const isMobile = /iPhone|Android|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const encodedText = encodeURIComponent(textMessage);
    const link = isMobile
      ? `https://wa.me/${phoneNumber}?text=${encodedText}`
      : `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedText}`;

    // Create an <a> element and simulate a click
    const a = document.createElement('a');
    a.href = link;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.click();
  };

  return (
    <>
      <Header />
      <Sidebar />
      <div className="uni_wrapper bg">
        <div className="uni_container5">
          <div className="property_list_screen_div">
            <div className="property_list_div_wrapper">
              <div className="property_grid_div">
                {properties.length === 0 ? (
                  <div className="no_data_message">No Favourites found</div>
                ) : (
                  properties.map((property, index) => (
                    <div
                      className="property_grid_one property_grid_new_class"
                      key={property._id || index}
                    >
                      <div className="propety_grid_img">
                        <img
                          className="propety_grid_img_display"
                          src={property.images[0] || noimage}
                          alt="Property"
                        />

                        <div
                          className="heart_div_2"
                          onClick={() => handleClick(property._id)}
                        >
                          <img
                            src={property?.isFavorite ? redHeart : heart}
                            alt="Favorite"
                          />
                        </div>
                      </div>
                      <div className="property_grid_data">
                        <div className="property_grid_content">
                          <div className="property_data">
                            <div className="property_para_div">
                              <p className="property_data_para">Locality:</p>
                              <p className="property_data_para2">
                                {property.locality.name || "N/A"}
                              </p>
                            </div>
                            <div className="property_para_div">
                              <p className="property_data_para">BHK:</p>
                              <p className="property_data_para2">
                                {property.bhk?.bhk || "N/A"}
                              </p>
                            </div>
                            <div className="property_para_div">
                              <p className="property_data_para">Contact:</p>
                              <p className="property_data_para2">
                                {property.phoneNo || "N/A"}
                              </p>
                            </div>
                          </div>
                          <div className="property_data">
                            <div className="property_para_div">
                              <p className="property_data_para">Address:</p>
                              <p className="property_data_para2">
                                {property.address || "N/A"}
                              </p>
                            </div>
                            <div className="property_para_div">
                              <p className="property_data_para">
                                Property Type:
                              </p>
                              <p className="property_data_para2">
                                {property.propertytype?.propertyType || "N/A"}
                              </p>
                            </div>
                          </div>
                          <div className="property_data">
                            <div className="property_para_div">
                              <p className="property_data_para">Area:</p>
                              <p className="property_data_para2">
                                {property.area || "N/A"}
                              </p>
                            </div>
                            <div className="property_para_div">
                              <p className="property_data_para">Price:</p>
                              <p className="property_data_para2">
                                {property.price || "N/A"}
                              </p>
                            </div>
                          </div>
                          <div className="property_data">
                            <div className="property_para_div">
                              <p className="property_data_para">Floor:</p>
                              <p className="property_data_para2">
                                {property.floor?.floor || "N/A"}
                              </p>
                            </div>
                            <div className="property_para_div">
                              <p className="property_data_para">Owner Name:</p>
                              <p className="property_data_para2">
                                {property.ownerName || "N/A"}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="remark_button_wrapper_div">
                          <p>Remark</p>
                          <input
                            type="text"
                            placeholder="Type something for your own use..."
                          />
                          <div className="submit_btn_icon_wrapper">
                            <button>Submit</button>
                            <div
                              className="d-flex"
                              style={{ columnGap: "12px" }}
                            >
                              {/* <div className='icon_1_div'
                                                               
                                                            >
                                                                <img src={heart} alt='Favorite' />
                                                            </div> */}
                              <div className="icon_1_div"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => openWhatsAppLink(e, `91${property.phoneNo}`, `Hi ${property.ownerName}, I am interested in your ${property.propertytype?.propertyType} at ${property.address}, ${property.locality?.name}`)}
                              >
                                <img src={whatsapp} alt="WhatsApp" />
                              </div>
                              <div className="icon_1_div"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleShareClick(property)}
                              >
                                <img src={arrow2} alt="Share" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="plus_div_icon">
                        <img src={plus} alt="Add" />
                      </div> */}
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListOfFavourites;
